import { normalizeSummaryCell, normalizeSummaryRow } from '../features/summary/renderSummary';
import { SummaryCellBuilder } from './SummaryCellBuilder';

export class SummaryRowBuilder {
    constructor() {
        this._row = {
            label: '',
            className: '',
            labelClassName: '',
            cells: []
        };
    }

    withLabel(label) {
        this._row.label = label;
        return this;
    }

    withClass(className) {
        this._row.className = className;
        return this;
    }

    withLabelClass(className) {
        this._row.labelClassName = className;
        return this;
    }

    /**
     * Marks this summary row as a "header row" so it can be styled
     * similarly to the DataTable header.
     * @returns {this}
     */
    asHeader(enabled = true) {
        if (!enabled) return this;
        const cls = 'dt-summary-header-row';
        const existing = String(this._row.className || '').trim();
        const next = existing ? `${existing} ${cls}` : cls;
        this._row.className = Array.from(new Set(next.split(/\s+/).filter(Boolean))).join(' ');
        return this;
    }

    withCell(cellOrBuilderFn) {
        if (typeof cellOrBuilderFn === 'function') {
            const builder = new SummaryCellBuilder();
            cellOrBuilderFn(builder);
            this._row.cells.push(builder.build());
            return this;
        }

        this._row.cells.push(normalizeSummaryCell(cellOrBuilderFn));
        return this;
    }

    withValue(value, format = null, id = '') {
        const cell = { value };
        if (typeof format === 'function') {
            cell.format = format;
        }
        if (id) {
            cell.id = id;
        }
        this._row.cells.push(normalizeSummaryCell(cell));
        return this;
    }

    build() {
        return normalizeSummaryRow(this._row);
    }
}
